import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import './ImageLightbox.css'

export default function ImageLightbox({ images, initialIndex = 0, title, onClose }) {
  const [selectedIndex, setSelectedIndex] = useState(initialIndex)

  useEffect(() => {
    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', handleKeyDown)
    return () => {
      document.body.style.overflow = previousOverflow
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [onClose])

  if (!images?.length) return null

  return createPortal(
    <div className="image-lightbox" role="dialog" aria-modal="true" aria-label={`${title} image viewer`}>
      <button className="image-lightbox__close" type="button" onClick={onClose} aria-label="Close full-screen images">
        <span aria-hidden="true">&times;</span>
      </button>
      <div className="image-lightbox__counter" aria-live="polite">
        {selectedIndex + 1} / {images.length}
      </div>
      <div className="image-lightbox__carousel">
        <Carousel
          selectedItem={selectedIndex}
          onChange={setSelectedIndex}
          showArrows={images.length > 1}
          showThumbs={false}
          showStatus={false}
          infiniteLoop={images.length > 1}
          autoPlay={false}
          swipeable
          emulateTouch
          useKeyboardArrows
        >
          {images.map((image, index) => (
            <div className="image-lightbox__slide" key={`${image}-${index}`}>
              <img src={image} alt={`${title} image ${index + 1}`} />
            </div>
          ))}
        </Carousel>
      </div>
    </div>,
    document.body
  )
}
